export default __webpack_public_path__ + "static/media/tic-tac-toe.21f7deca.png";